import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './routes'
import Directives from './plugins/directives'
import Filters from './plugins/filters'

Vue.config.productionTip = false
Vue.prototype.$baseApiUrl = '/boostbuttons-api'
Vue.prototype.$backstageUrl = 'https://backstage.ents24.com'
Vue.prototype.$gaEventCategory = 'Boost Buttons'
Vue.use(VueRouter)
Vue.use(Directives)
Vue.use(Filters)

const router = new VueRouter({
	routes,
	/**
	 * Control scroll behaviour on navigate. See
	 * https://router.vuejs.org/en/advanced/scroll-behavior.html
	 * @param  {Object} to            Route object user is arriving at
	 * @param  {Object} from          Route object user is leaving
	 * @param  {Object} savedPosition A pair of x / y coordinates - only set if this is a history pop
	 * @return {Object}               A pair of x / y coordinates; where to scroll to
	 */
	scrollBehavior (to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 } ;
	},
	base : '/boostbuttons/'
});

Vue.use(VueAnalytics, {
	id: 'UA-263375-1',
	router,
	debug: {
		enabled: process.env.NODE_ENV === 'development',
		sendHitTask: process.env.NODE_ENV === 'production'
	}
});

new Vue({
	render: h => h(App),
	router
}).$mount('#app');
